import React from "react";

// Bussola stilizzata, minimale, editoriale — non "erboristeria".
export default function CompassRose({ size = 220, className = "" }) {
  return (
    <div
      className={className}
      style={{ width: size, height: size, position: "relative" }}
      data-testid="compass-rose"
    >
      {/* Anello esterno */}
      <svg
        viewBox="0 0 200 200"
        width={size}
        height={size}
        style={{ position: "absolute", inset: 0 }}
      >
        <defs>
          <radialGradient id="ac-glow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#F7F3E9" stopOpacity="0.9" />
            <stop offset="60%" stopColor="#F3EFEA" stopOpacity="0.3" />
            <stop offset="100%" stopColor="#FAF8F5" stopOpacity="0" />
          </radialGradient>
          <linearGradient id="ac-needle" x1="0" x2="0" y1="0" y2="1">
            <stop offset="0%" stopColor="#C5A059" />
            <stop offset="100%" stopColor="#A28B97" />
          </linearGradient>
        </defs>
        <circle cx="100" cy="100" r="98" fill="url(#ac-glow)" />
      </svg>

      {/* Anello con tacche - ruota lento */}
      <svg
        viewBox="0 0 200 200"
        width={size}
        height={size}
        className="ac-spin-slow"
        style={{ position: "absolute", inset: 0 }}
      >
        <circle cx="100" cy="100" r="86" fill="none" stroke="rgba(43,40,37,0.12)" strokeWidth="0.6" />
        {Array.from({ length: 36 }).map((_, i) => {
          const angle = (i * 10 * Math.PI) / 180;
          const x1 = 100 + Math.cos(angle) * 82;
          const y1 = 100 + Math.sin(angle) * 82;
          const x2 = 100 + Math.cos(angle) * (i % 3 === 0 ? 72 : 78);
          const y2 = 100 + Math.sin(angle) * (i % 3 === 0 ? 72 : 78);
          return (
            <line
              key={i}
              x1={x1}
              y1={y1}
              x2={x2}
              y2={y2}
              stroke="rgba(43,40,37,0.28)"
              strokeWidth={i % 9 === 0 ? 0.9 : 0.5}
            />
          );
        })}
      </svg>

      {/* Anello interno - ruota inverso */}
      <svg
        viewBox="0 0 200 200"
        width={size}
        height={size}
        className="ac-spin-slower"
        style={{ position: "absolute", inset: 0 }}
      >
        <circle cx="100" cy="100" r="58" fill="none" stroke="rgba(197,160,89,0.35)" strokeWidth="0.5" />
        <circle cx="100" cy="100" r="42" fill="none" stroke="rgba(162,139,151,0.35)" strokeWidth="0.5" />
      </svg>

      {/* Ago fisso */}
      <svg
        viewBox="0 0 200 200"
        width={size}
        height={size}
        style={{ position: "absolute", inset: 0 }}
      >
        <g>
          <polygon points="100,26 106,100 100,110 94,100" fill="url(#ac-needle)" />
          <polygon points="100,174 94,100 100,90 106,100" fill="rgba(43,40,37,0.4)" />
          <circle cx="100" cy="100" r="5" fill="#2B2825" />
          <circle cx="100" cy="100" r="2" fill="#F7F3E9" />
        </g>
        <g fontFamily="Fraunces, serif" fill="#2B2825" fontSize="10" fontStyle="italic" textAnchor="middle">
          <text x="100" y="18">N</text>
          <text x="100" y="192">S</text>
        </g>
        <g fontFamily="Fraunces, serif" fill="#2B2825" fontSize="10" fontStyle="italic" textAnchor="middle" dominantBaseline="middle">
          <text x="8" y="100">O</text>
          <text x="192" y="100">E</text>
        </g>
      </svg>
    </div>
  );
}
